"use client"

import { useEffect } from "react"
import { useSession } from "@clerk/nextjs"
import { usePostHog } from "posthog-js/react"
import { PostHogPageView } from "@/lib2/client/telemetry/PostHogPageView"

export function Telemetry() {
  const posthog = usePostHog()
  const session = useSession()
  const userId = session.session?.user.externalId
  useEffect(() => {
    if (userId) {
      posthog.identify(userId, session.session?.publicUserData)
    }
  }, [userId, session.session?.publicUserData, posthog])
  return <PostHogPageView />
}
